import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
  standalone: true,
  selector: 'ml-custom-ag-grid-header',
  template: `
    <div class="ag-cell-label-container" role="presentation">
      <div class="ag-header-cell-label" role="presentation">
        <span class="ag-header-cell-text" role="columnheader">
          {{ params.displayName }}
        </span>
        <span class="ag-header-icon ag-sort-order" ref="eSortOrder"></span>
        <span class="ag-header-icon ag-sort-ascending-icon" ref="eSortAsc"></span>
        <span class="ag-header-icon ag-sort-descending-icon" ref="eSortDesc"></span>
        <span class="ag-header-icon ag-sort-none-icon" ref="eSortNone"></span>
      </div>
    </div>
  `,
})
export class CustomAgGridHeaderComponent implements IHeaderAngularComp {
  params!: IHeaderParams;

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    return true;
  }
}
